import type {Metric} from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // FID was removed in web-vitals v5; INP (Interaction to Next Paint) is
    // the successor Core Web Vital that replaces it. Report INP in FID's slot.
    import('web-vitals')
      .then(({onCLS, onINP, onFCP, onLCP, onTTFB}) => {
        onCLS(onPerfEntry);
        onINP(onPerfEntry);
        onFCP(onPerfEntry);
        onLCP(onPerfEntry);
        onTTFB(onPerfEntry);
      })
      // Background telemetry: if the chunk fails to load there is nothing to
      // report and nothing to tell the user about.
      .catch(() => {});
  }
};

export default reportWebVitals;
